
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 44 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"var(--status-svg-color)","cx":"22","cy":"22","r":"22"}}),_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M22.823 11.605a.67.67 0 10-1.333.135c.59 5.854.653 5.801.445 6.437a2.472 2.472 0 01-1.732 1.632.672.672 0 00-.502.672l.357 11.286a.851.851 0 01-.848.843.851.851 0 01-.848-.843l.356-11.286a.672.672 0 00-.5-.672 2.46 2.46 0 01-1.834-2.653l.546-5.416a.67.67 0 10-1.332-.135l-.546 5.416a3.803 3.803 0 002.312 3.916l-.341 10.8c-.035 1.14.92 2.218 2.187 2.218 1.262 0 2.222-1.072 2.187-2.218l-.341-10.8a3.802 3.802 0 002.312-3.916l-.545-5.416z"}}),_c('path',{attrs:{"d":"M19.21 17.367c.37 0 .67-.302.67-.673v-5.021c0-.372-.3-.673-.67-.673-.37 0-.67.301-.67.673v5.021c0 .371.3.673.67.673zM29.3 11c-2.585 0-4.688 2.112-4.688 4.708v10.401c0 .372.3.673.67.673h.669v5.156c0 1.112.901 2.017 2.009 2.017a2.016 2.016 0 002.009-2.017V11.673c0-.372-.3-.673-.67-.673zm-.67 20.938c0 .37-.3.672-.67.672a.672.672 0 01-.67-.672v-5.156h1.34v5.156zm0-6.501H25.95v-9.73a3.365 3.365 0 012.679-3.294v13.024z"}})])])])
          )
        }
      }
    